import React from "react";
import "../styles/App.css";
import { Link } from "react-router-dom";
import RotatingGallery from "../components/RotatingGallery";

const LandingPage = () => {
  const handleContactSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const name = formData.get("name") || "";
    const email = formData.get("email") || "";
    const message = formData.get("message") || "";

    const subject = encodeURIComponent(`New message from ${name}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\n${message}`
    );

    // TODO: replace with the actual email address you want messages sent to
    window.location.href = `mailto:gregmcmahon313@gmail.com?subject=${subject}&body=${body}`;

    e.target.reset();
  };

  return (
    <main className="bg-alice text-space min-h-screen flex flex-col px-6 py-16">
      <section className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-start">
        {/* Headshots */}
        <div className="flex flex-col gap-6">
          <div className="aspect-square rounded-2xl overflow-hidden border border-violet shadow-md">
            <img
              src="/images/headshot1.jpeg"
              alt="Portrait of Greg McMahon"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="aspect-square rounded-2xl overflow-hidden border border-violet shadow-md">
            <img
              src="/images/headshot2.jpeg"
              alt="Second portrait of Greg McMahon"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Bio + Listen + Contact */}
        <div>
          <p className="mt-4 text-lg text-space/80 leading-relaxed">
            Dramatic tenor Gregory McMahon brings searing intensity, generous tone, and heartfelt sincerity to the operatic stage. 
            Based in the Pacific Northwest, he is admired for his commanding presence and emotionally charged interpretations 
            across the operatic and classical concert repertoire.<br /><br />
            McMahon performs regularly throughout the region in staged productions, concerts, and intimate recital settings. 
            Whether presenting beloved standards or exploring lesser-known works, he is committed to sharing meaningful music 
            with audiences of all backgrounds, and is particularly drawn to repertoire that blends lyrical beauty with dramatic depth.<br /><br />
            Originally from Girard, Pennsylvania, McMahon has made the Pacific Northwest his artistic home since 2007. 
            His performances have reached traditional theaters, churches, and community venues, reflecting his belief that 
            great music should meet people wherever they are. He continues to build a broader presence through ongoing performances 
            and digital media, sharing recordings on Facebook and YouTube.<br /><br />
            Offstage, McMahon balances his artistic life with family, community, and continual study. 
            He is passionate about connecting with audiences through expressive storytelling and aims to expand his concert 
            and theatrical work across the region and beyond.
          </p>

          {/* Listen button */}
          <div className="mt-8">
            <a
              href="https://www.youtube.com/channel/UCBCdXKkGNWL2kJ4RSGbq-tA" // replace if needed
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-violet text-alice font-medium text-lg px-6 py-3 rounded-full shadow-md hover:bg-space hover:text-alice transition-colors duration-300"
            >
              Listen!
            </a>
          </div>

          {/* Contact form (mailto-based) */}
          <form
            onSubmit={handleContactSubmit}
            className="mt-10 bg-violet/5 border border-violet rounded-2xl p-6 shadow-md max-w-md"
          >
            <h2 className="text-2xl font-playfair font-bold text-space mb-4 text-center">
              Get in Touch
            </h2>

            <label className="block mb-3">
              <span className="text-space font-medium">Name</span>
              <input
                type="text"
                name="name"
                required
                className="w-full mt-1 p-2 rounded-md border border-violet/40 bg-alice focus:border-violet focus:outline-none"
              />
            </label>

            <label className="block mb-3">
              <span className="text-space font-medium">Email</span>
              <input
                type="email"
                name="email"
                required
                className="w-full mt-1 p-2 rounded-md border border-violet/40 bg-alice focus:border-violet focus:outline-none"
              />
            </label>

            <label className="block mb-4">
              <span className="text-space font-medium">Message</span>
              <textarea
                name="message"
                rows="4"
                required
                className="w-full mt-1 p-2 rounded-md border border-violet/40 bg-alice focus:border-violet focus:outline-none"
              ></textarea>
            </label>

            <button
              type="submit"
              className="w-full bg-violet text-alice font-medium py-2 rounded-full hover:bg-space transition-colors duration-300"
            >
              Send
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default LandingPage;




